const mapTabsState = new WeakMap();

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.map-tabs-wrapper').forEach(initMapWrapper);
});

function initMapWrapper(wrapper) {
  const mapContainer = getMapContainer(wrapper);
  if (!mapContainer) return;

  const firstParentTab = wrapper.querySelector('[data-parent-tab]');
  const state = {
    currentParentTab: firstParentTab ? firstParentTab.dataset.parentTab : null,
    mapContainer
  };

  mapTabsState.set(wrapper, state);

  wrapper.querySelectorAll('[data-parent-tab]').forEach(function(tab) {
    tab.addEventListener('click', function() {
      switchParentTabInWrapper(wrapper, tab.dataset.parentTab);
    });
  });

  wrapper.querySelectorAll('[data-map-section-toggle]').forEach(function(sectionToggle) {
    sectionToggle.addEventListener('click', function() {
      switchMapSectionInWrapper(wrapper, sectionToggle.closest('[data-map-section]'));
    });
  });

  wrapper.querySelectorAll('[data-location], [data-map-location]').forEach(function(locationEl) {
    const title = locationEl.querySelector('.accordion-title');
    if (!title) return;

    title.addEventListener('click', function() {
      switchLocationInWrapper(wrapper, locationEl);
    });
  });

  const firstLocation = wrapper.querySelector('.map-tabs-sub-tab.active, [data-map-location].active')
    || wrapper.querySelector('[data-location], [data-map-location]');

  if (firstLocation) {
    loadLocationMap(wrapper, firstLocation);
  }
}

function getMapContainer(wrapper) {
  return wrapper.querySelector('#map-tabs-map, .custom-service-tabs__map');
}

function getLocationId(locationEl) {
  return locationEl.dataset.location || locationEl.dataset.mapLocation || '';
}

function getLocationAddress(locationEl) {
  const addressLink = locationEl ? locationEl.querySelector('.map-tabs-detail-content.location .map-tabs-detail-text a') : null;
  if (!addressLink) return '';

  return addressLink.textContent.trim();
}

function getMapQuery(locationEl, lat, lng) {
  const latitude = parseFloat(lat);
  const longitude = parseFloat(lng);

  if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
    return `${latitude},${longitude}`;
  }

  return getLocationAddress(locationEl);
}

function loadLocationMap(wrapper, locationEl) {
  if (!locationEl) return;

  const query = getMapQuery(locationEl, locationEl.dataset.lat, locationEl.dataset.lng);
  loadGoogleMap(wrapper, query);
}

function loadGoogleMap(wrapper, query) {
  const state = mapTabsState.get(wrapper);
  const mapContainer = state ? state.mapContainer : getMapContainer(wrapper);

  if (!mapContainer || !query) return;

  ensureMapContainerSize(mapContainer);

  mapContainer.innerHTML = '';

  const iframe = document.createElement('iframe');
  iframe.src = `https://www.google.com/maps?q=${encodeURIComponent(query)}&z=15&output=embed`;
  const mapSize = getMapContainerSize(mapContainer);
  iframe.width = mapSize.width;
  iframe.height = mapSize.height;
  iframe.loading = 'lazy';
  iframe.referrerPolicy = 'no-referrer-when-downgrade';
  iframe.style.border = '0';
  iframe.style.width = `${mapSize.width}px`;
  iframe.style.height = `${mapSize.height}px`;
  iframe.allowFullscreen = true;

  mapContainer.appendChild(iframe);
}

function ensureMapContainerSize(mapContainer) {
  const rect = mapContainer.getBoundingClientRect();
  const height = Math.round(rect.height || mapContainer.offsetHeight || 0);

  if (height < 300) {
    mapContainer.style.height = '600px';
  }
}

function getMapContainerSize(mapContainer) {
  const rect = mapContainer.getBoundingClientRect();
  const width = Math.round(rect.width || mapContainer.offsetWidth || 600);
  const height = Math.round(rect.height || mapContainer.offsetHeight || 600);

  return {
    width: String(width),
    height: String(height)
  };
}

function switchParentTab(parentTabId) {
  const wrapper = getEventWrapper() || findWrapperByParentTab(parentTabId);
  if (!wrapper) return;

  switchParentTabInWrapper(wrapper, parentTabId);
}

function switchParentTabInWrapper(wrapper, parentTabId) {
  const state = mapTabsState.get(wrapper);
  if (state) state.currentParentTab = parentTabId;

  wrapper.querySelectorAll('[data-parent-tab]').forEach(function(tab) {
    tab.classList.toggle('active', tab.dataset.parentTab === parentTabId);
  });

  wrapper.querySelectorAll('[data-parent-content]').forEach(function(content) {
    content.classList.toggle('active', content.dataset.parentContent === parentTabId);
  });

  const firstLocation = wrapper.querySelector(`.map-tabs-parent-content[data-parent-content="${parentTabId}"] .map-tabs-sub-tab`);
  if (firstLocation) {
    switchLocationInWrapper(wrapper, firstLocation);
  }
}

function switchLocation(locationId, lat, lng) {
  const wrapper = getEventWrapper() || findWrapperByLocation(locationId);
  if (!wrapper) return;

  const locationEl = findLocationInWrapper(wrapper, locationId);
  if (!locationEl) return;

  switchLocationInWrapper(wrapper, locationEl, lat, lng);
}

function switchMapSectionInWrapper(wrapper, section) {
  if (!section) return;

  wrapper.querySelectorAll('[data-map-section]').forEach(function(item) {
    const isActive = item === section;
    item.classList.toggle('active', isActive);
    item.classList.toggle('open', isActive);
  });

  const firstLocation = section.querySelector('[data-location], [data-map-location]');
  if (firstLocation) {
    switchLocationInWrapper(wrapper, firstLocation);
  }
}

function switchLocationInWrapper(wrapper, locationEl, lat, lng) {
  const locationId = getLocationId(locationEl);
  const parentContent = locationEl.closest('.map-tabs-parent-content') || wrapper;
  const section = locationEl.closest('[data-map-section]');

  if (section) {
    wrapper.querySelectorAll('[data-map-section]').forEach(function(item) {
      const isActive = item === section;
      item.classList.toggle('active', isActive);
      item.classList.toggle('open', isActive);
    });
  }

  parentContent.querySelectorAll('[data-location], [data-map-location]').forEach(function(item) {
    const isActive = item === locationEl;
    item.classList.toggle('active', isActive);
    item.classList.toggle('open', isActive);
  });

  parentContent.querySelectorAll('[data-location-info], [data-map-location-info]').forEach(function(info) {
    const infoId = info.dataset.locationInfo || info.dataset.mapLocationInfo;
    info.style.display = infoId === locationId ? 'flex' : 'none';
  });

  const query = getMapQuery(locationEl, lat || locationEl.dataset.lat, lng || locationEl.dataset.lng);
  loadGoogleMap(wrapper, query);
}

function findLocationInWrapper(wrapper, locationId) {
  return wrapper.querySelector(`[data-location="${locationId}"], [data-map-location="${locationId}"]`);
}

function findWrapperByLocation(locationId) {
  const locationEl = document.querySelector(`[data-location="${locationId}"], [data-map-location="${locationId}"]`);
  return locationEl ? locationEl.closest('.map-tabs-wrapper') : null;
}

function findWrapperByParentTab(parentTabId) {
  const tab = document.querySelector(`[data-parent-tab="${parentTabId}"]`);
  return tab ? tab.closest('.map-tabs-wrapper') : null;
}

function getEventWrapper() {
  return window.event && window.event.target ? window.event.target.closest('.map-tabs-wrapper') : null;
}
